'use strict';

/** @type {import('./type')} */
module.exports = TypeError;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-errors/type.js
 ** module id = 15
 ** module chunks = 0
 **/